import Vue from 'vue';
import ElementUI from 'element-ui';
import Cookies from 'js-cookie';
import App from './App.vue';
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.scss';
import i18n from './lang';
import * as filters from './filters';

Vue.config.productionTip = false;
Cookies.defaults.expires = 10; // 设置 js-cookie 存储的信息的有效期为 10 天

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
